import {
  MessageBox,
  Message
} from "element-ui";
import axios from "axios";

const tokenKey = "masterKey";

// 根据环境自动切换服务器地址
// const ServerURL = "http://localhost:51219/webapi";
const ServerURL = "http://paiche.hbgcjc.com/webapi";
// const ServerURL = "http://192.168.50.75:8082/webapi";
// loading
function showLoading() {
  window._loading(true);
}

function hideLoading() {
  window._loading(false);
}

// token
function getToken() {
  return localStorage.getItem(tokenKey);
}

function setToken(token) {
  localStorage.setItem(tokenKey, token);
}

// 提示
function error(err) {
  return MessageBox.alert(err, {
    type: "error",
    // center: true
  });
}

function success(msg) {
  return Message.success(msg);
}

function confirm(content, title = "确认操作") {
  return MessageBox.confirm(content, title, {
    type: "warning",
    center: true,
    dangerouslyUseHTMLString: true,
  });
}


function sleep(ms) {
  return new Promise((resolve) => {
    let tt = setTimeout(() => {
      resolve();
      clearTimeout(tt);
    }, ms);
  });
}

//设置axios为form-data
axios.defaults.crossDomain = true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.transformRequest = [function (data) {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  return ret
}]

// 请求处理--对axios请求进行二次封装
const request = axios.create({
  // 远程服务器地址
  baseURL: ServerURL,
  // 超时
  timeout: 60 * 1000,
});

// 请求拦截
request.interceptors.request.use(
  (config) => {
    if (config.method != "get") {
      showLoading();
    }
    config.uid = localStorage.getItem('uid');
    if (config.params) {
      config.params.uid = localStorage.getItem('uid');
    } else {
      config.params = {
        uid: localStorage.getItem('uid')
      };
    }
    return config;
  },
  (err) => {
    // 请求失败 
    hideLoading();
    throw err;
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const {
      method,
      responseType,
      url
    } = response.config;
    hideLoading();
    // 身份验证失败
    if (response.status == 401) {
      // return window.top.location = "/#/login";
    }
    // 请求
    if (responseType === "blob") {
      if (response.status === 200) {
        return response;
      } else {
        let err = "请求文件出错 : 状态码错误!";
        error(err);
        throw err;
      }
    }
    // 正常的数据请求
    const {
      code,
      message,
      data
    } = response.data;

    // 服务器端返回错误
    if (code !== '0') {
      let err = message;
      error(err);
      throw error;
    }
    return data;
  },
  (err) => {
    hideLoading();
    throw err;
  }
);


function uploadFile(file, type) {
  if (!file) {
    return;
  }
  const param = new FormData();
  param.append("file", file);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const url = `/File/Upload`;
  return request.post(url, param, config);
}


export default {
  request,
  showLoading,
  hideLoading,
  getToken,
  setToken,
  error,
  success,
  confirm,
  sleep,
  uploadFile,
  ServerURL
};